"use strict"; // this is copied over from @ionic/react/dist/components/createComponent

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ReactDom = __importStar(require("react-dom"));

var arrayToMap = function arrayToMap(arr) {
  var map = new Map();
  arr.forEach(function (s) {
    return map.set(s, s);
  });
  return map;
};

var getClassName = function getClassName(classList, newProps, oldProps) {
  var newClassProp = newProps.className || newProps["class"];
  var oldClassProp = oldProps.className || oldProps["class"]; // map the classes to Maps for performance

  var currentClasses = arrayToMap(classList);
  var incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(" ") : []);
  var oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(" ") : []);
  var finalClassNames = []; // loop through each of the current classes on the component
  // to see if it should be a part of the classNames added

  currentClasses.forEach(function (currentClass) {
    if (incomingPropClasses.has(currentClass)) {
      // add it as its already included in classnames coming in from newProps
      finalClassNames.push(currentClass);
      incomingPropClasses["delete"](currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      // add it as it has NOT been removed by user
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach(function (s) {
    return finalClassNames.push(s);
  });
  return finalClassNames.join(" ");
};

var syncEvent = function syncEvent(node, eventName, newEventHandler) {
  var eventStore = node.__events || (node.__events = {});
  var oldEventHandler = eventStore[eventName]; // Remove old listener so they don't double up.

  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  } // Bind new listener.


  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    if (newEventHandler) {
      newEventHandler.call(this, e);
    }
  });
};

var attachEventProps = function attachEventProps(node, newProps, oldProps) {
  if (oldProps === void 0) {
    oldProps = {};
  } // add any classes in className to the class list


  var className = getClassName(node.classList, newProps, oldProps);

  if (className !== "") {
    node.className = className;
  }

  Object.keys(newProps).forEach(function (name) {
    if (name === "children" || name === "style" || name === "ref" || name === "className") {
      return;
    }

    if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
      var eventName = name.substring(2);
      var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);

      if (!isCoveredByReact(eventNameLc)) {
        syncEvent(node, eventNameLc, newProps[name]);
      }
    } else {
      node[name] = newProps[name];
    }
  });
};

var isCoveredByReact = function isCoveredByReact(eventNameSuffix, doc) {
  if (doc === void 0) {
    doc = document;
  }

  var eventName = "on" + eventNameSuffix;
  var isSupported = eventName in doc;

  if (!isSupported) {
    var element = doc.createElement("div");
    element.setAttribute(eventName, "return;");
    isSupported = typeof element[eventName] === "function";
  }

  return isSupported;
};

var dashToPascalCase = function dashToPascalCase(str) {
  return str.toLowerCase().split("-").map(function (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }).join("");
};

var createForwardRef = function createForwardRef(ReactComponent, displayName) {
  var forwardRef = function forwardRef(props, ref) {
    return React.createElement(ReactComponent, __assign({}, props, {
      forwardedRef: ref
    }));
  };

  forwardRef.displayName = displayName;
  return React.forwardRef(forwardRef);
};

exports.createReactComponentFromStencil = function (tagName) {
  var displayName = dashToPascalCase(tagName);

  var ReactComponent =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1(props) {
      return _super.call(this, props) || this;
    }

    class_1.prototype.componentDidMount = function () {
      this.componentDidUpdate(this.props);
    };

    class_1.prototype.componentDidUpdate = function (prevProps) {
      var node = ReactDom.findDOMNode(this);
      attachEventProps(node, this.props, prevProps);
    };

    class_1.prototype.render = function () {
      var _a = this.props,
          children = _a.children,
          forwardedRef = _a.forwardedRef,
          style = _a.style,
          className = _a.className,
          ref = _a.ref,
          cProps = __rest(_a, ["children", "forwardedRef", "style", "className", "ref"]);

      var propsToPass = Object.keys(cProps).reduce(function (acc, name) {
        if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) {
          var eventName = name.substring(2).toLowerCase();

          if (isCoveredByReact(eventName)) {
            acc[name] = cProps[name];
          }
        }

        return acc;
      }, {});

      var newProps = __assign(__assign({}, propsToPass), {
        ref: forwardedRef,
        style: style
      });

      return React.createElement(tagName, newProps, children);
    };

    Object.defineProperty(class_1, "displayName", {
      get: function get() {
        return displayName;
      },
      enumerable: true,
      configurable: true
    });
    return class_1;
  }(React.Component);

  return createForwardRef(ReactComponent, displayName);
};